import Vue from "vue"
/* import formsApi from "../../api/forms" */
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  name: undefined,
  type: undefined,
  types: undefined,
  config: undefined,
  body: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  form: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site

const initialState = {
  forms: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  forms: (state) => state.forms,
  formsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  formsError: (state) => state.error,
  forms_Object: (state) => state.object,
  forms_isNew: (state) => state.isNew,
  forms_selected: (state) => state.selected
}
const actions = {
  async DELETE_forms({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("forms", object)
    if (apiResponse != null) {
      //commit("FORMS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_forms", state.page)
      return true
    } else {
      commit("FORMS_ERROR")
      return false
    }
  },

  async DELETE_SELECTED_forms({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_forms", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_forms", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_formsState({ commit }, payload) {
    commit("SET_forms", payload)
    return true
  },
  async UPDATE_forms({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("forms", filtered)
    if (apiResponse != null) {
      commit("FORMS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_forms", state.page)
      return true
    } else {
      commit("FORMS_ERROR")
      return false
    }
  },
  async CREATE_forms({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("forms", object)
    if (apiResponse != null) {
      commit("SET_forms", {
        param: "object",
        value: apiResponse.form
      })
      dispatch("FETCH_PAGE_forms", state.page)
      return true
    } else {
      commit("FORMS_ERROR")
      return false
    }
  },
  async FETCH_forms({ commit }) {
    let apiResponse = await utilsApi.getObjects("forms")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("FORMS_SETTING", apiResponse)
      return true
    } else {
      commit("FORMS_ERROR")
      return false
    }
  },

  async FETCH_PAGE_forms({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("forms", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("FORMS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("FORMS_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_forms({ commit }, payload) {
    commit("SET_OBJECT_FORM", payload)
    return true
  },
  CLEAN_OBJECT_forms({ commit }) {
    commit("SET_OBJECT_FORM_INITIAL")
    return true
  },
  async CLEAN_STORE_forms({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_forms", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_forms({ commit }, payload) {
    commit("SET_SELECTED_FORMS", payload)
    return true
  }
}
const mutations = {
  FORMS_SETTING: (state, { forms, count = false, page }) => {
    //console.log(state)

    state.count = count || state.forms.length

    state.page = page || state.page
    state.forms = forms
    state.fetched = true
    state.error = false
  },
  FORMS_ERROR: (state) => {
    state.forms = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_FORM: (state, payload) => {
    //console.log("OBJECT", state.forms)
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_FORM_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_FORMS: (state, selectedMenus) => {
    state.selected = selectedMenus
  },
  SET_forms: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
